export default defineNuxtPlugin(() => {
  const isWebViewFlag = navigator.userAgent.includes('weathernews')

  return {
    provide: {
      isWebViewFlag
    }
  }
})
